import ImmutablePropTypes from "react-immutable-proptypes";
import PropTypes from "prop-types";
import React from "react";
import Table from "app/components/UI/Table";
import Title from "app/components/UI/Title";
import classes from "./Counter.module.css";
import moment from "moment";

const getCounterUnitType = typeId =>
  ({
    "/bluegreen/counter_units/1": "Practice",
    "/bluegreen/counter_units/2": "Golf Miniature"
  }[typeId]);

const CounterLines = ({ counterLines, notFound }) => {
  const head = ["Unités restantes / Nombre total d'unités", "Date de fin de validité", "Type", "Date d'achat"];
  const rows = counterLines
    .filter(cl => cl.get("remainingUnities"))
    .map(cl => [
      cl.get("@id"),
      `${cl.get("remainingUnities")} / ${cl.get("totalUnities")}`,
      moment(cl.get("validThrough")).format("DD/MM/YYYY"),
      getCounterUnitType(cl.get("unit")),
      moment(cl.get("createdAt")).format("DD/MM/YYYY")
    ]);

  return counterLines.size ? (
    <div>
      <Title className={classes.actual__sold}>Mon solde actuel</Title>
      <div className={classes.resultContainer}>
        <Table head={head} rows={rows} firstRowIsKey />
      </div>
    </div>
  ) : notFound ? (
    <Title component="h6" className={classes.no__result}>
      Le numéro de carte n’est pas reconnu ou aucun pack d’unités en cours n’a été trouvé
    </Title>
  ) : null;
};

CounterLines.PropTypes = {
  counterLines: ImmutablePropTypes.list.isRequired,
  notFound: PropTypes.bool.isRequired
};

export default CounterLines;



// WEBPACK FOOTER //
// ./src/app/components/Counter/CounterLines.js